module.exports = __webpack_public_path__ + "static/lyricsCover-217002704ec66e14610ad36ad6327156.png";